import { Injectable } from "@angular/core";
import { AngularFireStorage } from "@angular/fire/compat/storage";
import { Photo } from "@capacitor/camera";
import { finalize } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class StorageService {
  constructor(private storage: AngularFireStorage) {}

  public async upload(data: Photo): Promise<string> {
    const path = `${Date.now()}.${data.format}`;
    const file = this.b64toBlob(data.base64String, data.format);
    const ref = this.storage.ref(path);
    const task = this.storage.upload(path, file);

    return new Promise(resolve => {
      task
        .snapshotChanges()
        .pipe(
          finalize(async () => {
            const downloadURL = await ref.getDownloadURL().toPromise();
            return resolve(downloadURL);
          }),
        )
        .subscribe();
    });
  }

  public async uploadFromDataURL(dataUrl: string, type: string): Promise<string> {
    const ref = this.storage.ref(`${Date.now()}.${type}`);
    const task = ref.putString(dataUrl, "data_url");

    return new Promise(resolve => {
      task
        .snapshotChanges()
        .pipe(
          finalize(async () => {
            const downloadURL = await ref.getDownloadURL().toPromise();
            return resolve(downloadURL);
          }),
        )
        .subscribe();
    });
  }

  public async removeFromUrl(path: string): Promise<void> {
    await this.storage.storage.refFromURL(path).delete().catch(console.warn);
  }

  private b64toBlob(b64Data: string, contentType: string, sliceSize: number = 512): Blob {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);

      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  }
}
